export default "__VITE_ASSET__2d40cdbb__"